import {Injectable} from '@angular/core';
import {AvailableDepartmentType} from '../../shared/model/interface/department.model.interface';
import {ILegalCase} from '../../shared/model/interface/legal-case.model.interface';
import {IDepartmentChanged} from '../../shared/model/interface/department-changed.model.interface.ts';
import {LegalCase} from "../../shared/model/legal-case.model";

@Injectable({
  providedIn: 'root'
})
export class LegalCaseLinkService {

  constructor() {
  }

  public static createUrlForLegalCaseStatic(departmentType: AvailableDepartmentType, legalCaseId: number) {
    return this.resolveStatic(departmentType, legalCaseId);
  }

  private static resolveStatic(departmentType: AvailableDepartmentType, legalCaseId: number) {
    switch (departmentType) {
      case AvailableDepartmentType.PREVINDICATION:
        return `/previndications/${legalCaseId}`;
      case AvailableDepartmentType.ADMINISTRATION_CASE:
        return `/administration-cases/${legalCaseId}`;
      case AvailableDepartmentType.CIVIL_CASE:
        return `/civil-cases/${legalCaseId}`;
      case AvailableDepartmentType.CRIMINAL_CASE:
        return `/criminal-cases/${legalCaseId}`;
      case AvailableDepartmentType.INITIAL_VERIFICATION:
        return `/initial-verifications/${legalCaseId}`;
      case AvailableDepartmentType.MONITORED_PAYMENT:
        return `/monitored-payments/${legalCaseId}`;
      case AvailableDepartmentType.REGULAR_ACCOUNT:
        return `/regulars/${legalCaseId}`;
      case AvailableDepartmentType.RELOCATION_AND_RELEASE:
        return `/relocations-and-releases/${legalCaseId}`;
      case AvailableDepartmentType.VINDICATION:
        return `/vindications/${legalCaseId}`;
      case AvailableDepartmentType.INTERNATIONAL:
        return `/international-cases/${legalCaseId}`
    }
  }

  createUrlForLegalCaseAndDepartment(departmentType: AvailableDepartmentType, legalCaseId: number) {
    return this.resolve(departmentType, legalCaseId);
  }

  createUrlForLegalCase(legalCase: ILegalCase) {
    return this.resolve(legalCase.department.type, legalCase.id);
  }

  createUrlForDepartmentChanged(departmentChanged: IDepartmentChanged) {
    return this.resolve(departmentChanged.departmentType, departmentChanged.legalCaseId);
  }

  private resolve(departmentType: AvailableDepartmentType, legalCaseId: number) {
    switch (departmentType) {
      case AvailableDepartmentType.PREVINDICATION:
        return `/previndications/${legalCaseId}`;
      case AvailableDepartmentType.ADMINISTRATION_CASE:
        return `/administration-cases/${legalCaseId}`;
      case AvailableDepartmentType.CIVIL_CASE:
        return `/civil-cases/${legalCaseId}`;
      case AvailableDepartmentType.CRIMINAL_CASE:
        return `/criminal-cases/${legalCaseId}`;
      case AvailableDepartmentType.INITIAL_VERIFICATION:
        return `/initial-verifications/${legalCaseId}`;
      case AvailableDepartmentType.MONITORED_PAYMENT:
        return `/monitored-payments/${legalCaseId}`;
      case AvailableDepartmentType.REGULAR_ACCOUNT:
        return `/regulars/${legalCaseId}`;
      case AvailableDepartmentType.RELOCATION_AND_RELEASE:
        return `/relocations-and-releases/${legalCaseId}`;
      case AvailableDepartmentType.VINDICATION:
        return `/vindications/${legalCaseId}`;
      case AvailableDepartmentType.INTERNATIONAL:
        return `/international-cases/${legalCaseId}`
    }
  }
}
